<template>
    <div class="account-content">
        <div class="row">
            <div class="col-xs-12">
                <p class="text-mutted"><b>Selecione a forma como você deseja recuperar sua senha de acesso:</b></p>
            </div>

            <div class="col-xs-12 m-t-20">
                <div class="radio radio-success radio-inline">
                    <input type="radio" id="email" value="email" name="method" v-model="method">
                    <label for="email"> Enviar link de recuperação para o email <b>{{ email }}</b>. </label>
                </div>
            </div>

            <div class="col-xs-12 m-t-10" v-if="cellphone">
                <div class="radio radio-success radio-inline">
                    <input type="radio" id="cellphone" value="cellphone" name="method" v-model="method">
                    <label for="cellphone"> Enviar código de recuperação por SMS para <b>{{ cellphone }}</b>. </label>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <button type="button" @click="submitForm()" class="btn btn-success btn-block waves-effect waves-light m-t-20 ladda-button password-btn">
                    <span class="ladda-label">Enviar</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['cellphone', 'email', 'full_email'],
    data() {
        return {
            method: ''
        }
    },
    methods: {
        submitForm() {
            let obj = {
                method: this.method,
                email: this.full_email
            }

            let l = Ladda.create( this.$el.querySelector('.ladda-button') );
            l.start();
            axios.post('/auth/password/request', obj).then(res => {
                this.$emit('request_sent', this.method);
            }).finally(() => { l.stop() });
        }
    }
}
</script>
